/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Plan_Title_LeadInputs */

const en_platform_plan_title_lead = /** @type {(inputs: Platform_Plan_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 12-week plan.`)
};

const pl_platform_plan_title_lead = /** @type {(inputs: Platform_Plan_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan na 12 tygodni.`)
};

/**
* | output |
* | --- |
* | "A 12-week plan." |
*
* @param {Platform_Plan_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_plan_title_lead = /** @type {((inputs?: Platform_Plan_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Plan_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_plan_title_lead(inputs)
	return en_platform_plan_title_lead(inputs)
});